function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#0a0a29",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    id: "payment-error",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon line",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("line", {
    id: "primary-upstroke",
    x1: 16.6,
    y1: 14.19,
    x2: 16.5,
    y2: 14.19,
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.95
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "primary-upstroke-2",
    "data-name": "primary-upstroke",
    x1: 14.6,
    y1: 14.19,
    x2: 14.5,
    y2: 14.19,
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.95
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M12,19h8a1,1,0,0,0,1-1V6a1,1,0,0,0-1-1H4A1,1,0,0,0,3,6v4",
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.5
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "primary-2",
    "data-name": "primary",
    x1: 7,
    y1: 11,
    x2: 7,
    y2: 14,
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.5
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "primary-upstroke-3",
    "data-name": "primary-upstroke",
    x1: 6.95,
    y1: 18.5,
    x2: 7.05,
    y2: 18.5,
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.95
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZero);
export default __webpack_public_path__ + "static/media/zero.81c5b6aa4224d7850228896ab704ca31.svg";
export { ForwardRef as ReactComponent };